import React from 'react'
import Header from 'components/Header'
import ConsultCategoryItem from 'components/consult/ConsultCategoryItem'
import Loading from 'components/Loading'
import DoctorListItem from 'components/consult/DoctorListItem'
import SearchIcon from '@material-ui/icons/Search'
import utils from 'Utils'
import axios from 'axios'
import { Redirect, Link } from 'react-router-dom'
import 'style/consult/category-list.css'

class CategoryList extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            categories: [],
            categoryToShow: [],
            doctors: [],
            redirect: ''
        }
    }

    componentDidMount() {
        if (window.localStorage.getItem('questionFromBlog'))
            this.setState({ redirect: { pathname: '/consult/new' } })

        this.getConsultCategories()
    }

    getConsultCategories = async () => {
        this.setState({ loading: true })

        const res = await axios.get(utils.urls.consultCategories)
            .catch((e) => {
                console.log(e.response)
                let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
                this.SnackBar.openSnackbar(message)
            })

        this.setState({ loading: false })

        if (!res) return
        if (!res.data.success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')

        this.setState({
            categories: res.data.consultCategories,
            categoryToShow: res.data.consultCategories
        })
    }

    handleChange = e => {
        this.searchCat(e)
        this.searchDoctor(e)
    }

    searchCat = e => {
        if (!e.target.value)
            this.setState({ categoryToShow: this.state.categories })
        else
            this.setState({ categoryToShow: this.state.categories.filter(cat => cat.name.includes(e.target.value)) })
    }

    searchDoctor = async e => {
        if (!e.target.value || e.target.value.length < 3) return this.setState({ doctors: [] })

        const res = await axios.get(utils.urls.searchDoctor + `?query=${e.target.value}`)
            .catch((e) => {
                console.log(e.response)
                let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
                this.SnackBar.openSnackbar(message)
            })

        if (!res) return
        if (!res.data.success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')

        this.append(res.data)
    }

    append = data => {
        const complex = {}

        data.doctors.map(doctor => {
            complex[doctor.id] = doctor
        })

        data.consultRating.map(item => {
            if (complex[item.doctorId]) {
                complex[item.doctorId] = {
                    ...complex[item.doctorId],
                    rateItem: item
                }
            }
        })

        this.setState({ doctors: Object.values(complex) });
    }

    async clickOnDoctorItem() {
        console.log('tag manager', 'select doctor')
        utils.sendGtmEvent('Convert', 'Click on Doctor')
    }

    render() {
        if (this.state.redirect) return <Redirect to={this.state.redirect} push />

        return (
            <>
                <Header showBackButton title='دسته بندی ها' />
                <div className="page-root" >
                    <div style={{ paddingRight: '10px', paddingLeft: '10px', overflowY: 'auto', flexGrow: 1 }}>
                        <h3>ابتدا نوع مشاوره را مشخص کنید</h3>
                        <div className="search-box">
                            <input ref={el => this.searchInput = el} onChange={this.handleChange} placeholder="جستجوی تخصص یا موضوع مشاوره" />
                            <SearchIcon style={{ marginRight: 5 }} onClick={() => this.searchInput.focus()} />
                        </div>
                        {!this.state.loading ?
                            <>
                                <div className="categories">
                                    {this.state.categoryToShow.length > 0 &&
                                        <>
                                            <div className="title">انتخاب دسته‌بندی</div>
                                            {
                                                this.state.categoryToShow.map(category =>
                                                    <ConsultCategoryItem key={category.id} category={category} />
                                                )
                                            }
                                        </>
                                    }
                                </div>
                                <div className="doctors">
                                    {this.state.doctors.length > 0 &&
                                        <>
                                            <div className="title">پرسش از پزشک دلخواه</div>
                                            {this.state.doctors.map(doctor =>
                                                <Link key={doctor.id} to={`/doctors/${doctor.id}`} onClick={this.clickOnDoctorItem}>
                                                    <DoctorListItem doctor={doctor} />
                                                </Link>
                                            )}
                                        </>
                                    }
                                </div>
                            </> :
                            <div className="loading">
                                <Loading />
                            </div>
                        }
                    </div>
                </div>
            </>
        )
    }
}

export default CategoryList